/*eslint-disable */
export function debugLog() {
  if (process.env.REACT_APP_DEBUG_LOGS){
     console.log(...arguments);
  }
}

export function debugLogic(value) {
  console.log(value, '1122');
}